import $ from 'jquery';
$(document).ready(function ($) {
    $('#js-sticky-home__close').click(function(){
        $('#js-sticky-home').addClass('uk-hidden');
    });
});